module.exports = __webpack_public_path__ + "img/winterbs.bddaac1a.webp";